export default __webpack_public_path__ + "static/media/bumperStickers.7fb949ce.png";